import React from 'react';

const blogs = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center vh-100 px-3">
      <h1 className="display-2 fw-bold mb-3">Blogs are Brewing!</h1>
      <p className="lead text-secondary fs-4">
        We're cooking up some amazing stories and insights for you.
        <br />Stay tuned — our blog page will be live soon! 🚀
      </p>
    </div>
  );
};

export default blogs;

